import ArbitrumLogo from "../images/ArbitrumLogo.svg";
import AvalancheLogo from "../images/AvalancheLogo.svg";
import BaseLogo from "../images/BaseLogo.svg";
import USDLogo from "../images/USDLogo.svg";
import BRLLogo from "../images/BRLLogo.svg";
import MXNLogo from "../images/MXNLogo.svg";
import BatLogo from "../images/BAT.svg";
import BNBLogo from "../images/BNBLogo.svg";
import BTCLogo from "../images/BTCLogo.svg";
import BUSDLogo from "../images/BUSDLogo.svg";
import DogeLogo from "../images/DogeLogo.svg";
import DotLogo from "../images/DOT.svg";
import WethLogo from "../images/WETH.svg";
import EthLogo from "../images/EthLogo.svg";
import LitecoinLogo from "../images/LitecoinLogo.svg";
import OptimismLogo from "../images/OptimismLogo.svg";
import PolygonLogo from "../images/PolygonLogo.svg";
import SolLogo from "../images/Solana.svg";
import UDSTLogo from "../images/TetherLogo.svg";
import TronLogo from "../images/TronLogo.svg";
import USDCLogo from "../images/USDCLogo.svg";
import EUROCLogo from "../images/EUROCLogo.svg";
import EVMLogo from "../images/EVMLogo.svg";
import { IPaymentMethod, DepositStatus } from "../state/Radom";
import EUROLogo from "../images/EUROLogo.svg";
import GBPLogo from "../images/GBPLogo.svg";
import BSVLogo from "../images/BSVLogo.svg";
import BCHLogo from "../images/BCHLogo.svg";

export interface ManagedPaymentMethod {
  name: string;
  logo?: any;
  currencyName?: string;
  ticker: string;
  chainId?: number;
  hostChain?: {
    tokenAddress: string;
    name: string;
    logo: any;
  };
  isSwapEnabled?: boolean;
  isTestnet?: boolean;
  isDisabled?: boolean;
  isHidden?: boolean;
  isFiat?: boolean;
}

interface ISubToken {
  name: string;
  logo: any;
  ticker: string;
  method: IPaymentMethod;
}

interface ISubNetwork {
  name: string;
  logo: any;
  ticker?: string;
  subMethods?: ISubToken[];
  method?: IPaymentMethod;
}

interface IDepositMethods {
  name: string;
  logo: any;
  description: string;
  ticker?: string;
  subMethods?: ISubNetwork[];
  isTestnet?: boolean;
  isHidden?: boolean;
}

export const DepositMethods: IDepositMethods[] = [
  {
    name: "Bitcoin",
    logo: BTCLogo,
    description: "Accept deposits on Bitcoin network",
  },
  {
    name: "Dogecoin",
    logo: DogeLogo,
    description: "Accept deposits on Dogecoin network",
  },
  {
    name: "Litecoin",
    logo: LitecoinLogo,
    description: "Accept deposits on Litecoin network",
  },
  {
    name: "BitcoinCash",
    logo: BCHLogo,
    description: "Accept deposits on BitcoinCash network",
  },
  {
    name: "BitcoinSV",
    logo: BSVLogo,
    description: "Accept deposits on BitcoinSV network",
    isHidden: true,
  },
  {
    name: "BitcoinTestnet",
    logo: BTCLogo,
    isTestnet: true,
    description: "Accept deposits on Bitcoin test network",
  },
  {
    name: "LitecoinTestnet",
    logo: LitecoinLogo,
    isTestnet: true,
    description: "Accept deposits on Litecoin test network",
  },
  {
    name: "BitcoinCashTestnet",
    logo: BCHLogo,
    isTestnet: true,
    description: "Accept deposits on BitcoinCash test network",
  },
  {
    name: "SepoliaTestnet",
    logo: EthLogo,
    isTestnet: true,
    description: "Accept deposits on SepoliaTestnet",
    subMethods: [
      {
        name: "Ether",
        logo: EthLogo,
        ticker: "ETH",
        method: {
          network: "SepoliaTestnet",
        },
      },
      {
        name: "USD Coin",
        logo: USDCLogo,
        ticker: "USDC",
        method: {
          network: "SepoliaTestnet",
          token: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
        },
      },
      {
        name: "Tether",
        logo: UDSTLogo,
        ticker: "USDT",
        method: {
          network: "SepoliaTestnet",
          token: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
        },
      },
    ],
  },
  {
    name: "EVM",
    logo: EVMLogo,
    description: "Accept deposits on all supported EVM networks",
    subMethods: [
      {
        name: "Ethereum",
        logo: EthLogo,
        subMethods: [
          {
            name: "Ether",
            ticker: "ETH",
            logo: EthLogo,
            method: {
              network: "Ethereum",
            },
          },
          {
            name: "USD Coin",
            ticker: "USDC",
            logo: USDCLogo,
            method: {
              network: "Ethereum",
              token: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            },
          },
          {
            name: "Tether",
            ticker: "USDT",
            logo: UDSTLogo,
            method: {
              network: "Ethereum",
              token: "0xdac17f958d2ee523a2206206994597c13d831ec7",
            },
          },
          {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: BatLogo,
            method: {
              network: "Ethereum",
              token: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
            },
          },
        ],
      },
      {
        name: "Polygon",
        logo: PolygonLogo,
        subMethods: [
          {
            name: "Polygon",
            ticker: "POL",
            logo: PolygonLogo,
            method: {
              network: "Polygon",
            },
          },
          {
            name: "USD Coin",
            ticker: "USDC",
            logo: USDCLogo,
            method: {
              network: "Polygon",
              token: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
            },
          },
          {
            name: "Tether",
            ticker: "USDT",
            logo: UDSTLogo,
            method: {
              network: "Polygon",
              token: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
            },
          },
          {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: BatLogo,
            method: {
              network: "Polygon",
              token: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
            },
          },
        ],
      },
      {
        name: "BNB",
        logo: BNBLogo,
        subMethods: [
          {
            name: "BNB",
            ticker: "BNB",
            logo: BNBLogo,
            method: {
              network: "BNB",
            },
          },
          {
            name: "USD Coin",
            ticker: "USDC",
            logo: USDCLogo,
            method: {
              network: "BNB",
              token: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
            },
          },
          {
            name: "Tether",
            ticker: "USDT",
            logo: UDSTLogo,
            method: {
              network: "BNB",
              token: "0x55d398326f99059ff775485246999027b3197955",
            },
          },
          {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: BatLogo,
            method: {
              network: "BNB",
              token: "0x101d82428437127bf1608f699cd651e6abf9766e",
            },
          },
        ],
      },
      {
        name: "Base",
        logo: BaseLogo,
        subMethods: [
          {
            name: "Ether",
            ticker: "ETH",
            logo: EthLogo,
            method: {
              network: "Base",
            },
          },
          {
            name: "USD Coin",
            ticker: "USDC",
            logo: USDCLogo,
            method: {
              network: "Base",
              token: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
            },
          },
        ],
      },
      {
        name: "Arbitrum",
        logo: ArbitrumLogo,
        subMethods: [
          {
            name: "Ether",
            ticker: "ETH",
            logo: EthLogo,
            method: {
              network: "Arbitrum",
            },
          },
          {
            name: "USD Coin",
            ticker: "USDC",
            logo: USDCLogo,
            method: {
              network: "Arbitrum",
              token: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
            },
          },
          {
            name: "Tether",
            ticker: "USDT",
            logo: UDSTLogo,
            method: {
              network: "Arbitrum",
              token: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
            },
          },
        ],
      },
      {
        name: "Avalanche",
        logo: AvalancheLogo,
        subMethods: [
          {
            name: "Avalanche",
            ticker: "AVAX",
            logo: AvalancheLogo,
            method: {
              network: "Avalanche",
            },
          },
          {
            name: "Tether",
            ticker: "USDT",
            logo: UDSTLogo,
            method: {
              network: "Avalanche",
              token: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
            },
          },
        ],
      },
    ],
  },
  {
    name: "Tron",
    logo: TronLogo,
    description: "Accept deposits on Tron",
    subMethods: [
      {
        name: "Tron",
        ticker: "TRX",
        logo: TronLogo,
        method: {
          network: "Tron",
        },
      },
      {
        name: "Tether",
        ticker: "USDT",
        logo: UDSTLogo,
        method: {
          network: "Tron",
          token: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
        },
      },
    ],
  },
  {
    name: "Solana",
    logo: SolLogo,
    description: "Accept deposits on Solana",
    subMethods: [
      {
        name: "Solana",
        ticker: "SOL",
        logo: SolLogo,
        method: {
          network: "Solana",
        },
      },
      {
        name: "USDT",
        ticker: "USDT",
        logo: UDSTLogo,
        method: {
          network: "Solana",
          token: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
        },
      },
      {
        name: "USDC",
        ticker: "USDC",
        logo: USDCLogo,
        method: {
          network: "Solana",
          token: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
        },
      },
    ],
  },
  // {
  //   name: 'Solana Devnet',
  //   logo: SolLogo,
  //   isTestnet: true,
  //   description: 'Accept deposits on Solana Devnet',
  //   subMethods: [
  //     {
  //       name: 'Solana Devnet',
  //       ticker: 'SOL',
  //       logo: SolLogo,
  //       method: {
  //         network: 'SolanaDevnet'
  //       }
  //     },
  //     {
  //       name: 'USDC',
  //       ticker: 'USDC',
  //       logo: USDCLogo,
  //       method: {
  //         network: 'SolanaDevnet',
  //         token: 'Gh9ZwEmdLJ8DscKNTkTqPbNwLNNBjuSzaG9Vp2KGtKJr'
  //       }
  //     }
  //   ]
  // }
];

export const getPaymentMethods = (): ManagedPaymentMethod[] => {
  return [
    {
      name: "Bitcoin",
      logo: BTCLogo,
      ticker: "BTC",
      isSwapEnabled: true,
    },
    {
      name: "BitcoinTestnet",
      currencyName: "Bitcoin",
      logo: BTCLogo,
      ticker: "BTC",
      isTestnet: true,
    },
    {
      name: "Litecoin",
      logo: LitecoinLogo,
      ticker: "LTC",
      isSwapEnabled: true,
    },
    {
      name: "LitecoinTestnet",
      currencyName: "Litecoin",
      logo: LitecoinLogo,
      ticker: "LTC",
      isTestnet: true,
    },
    {
      name: "Dogecoin",
      logo: DogeLogo,
      ticker: "DOGE",
      isSwapEnabled: true,
    },
    {
      name: "BitcoinCash",
      currencyName: "Bitcoin Cash",
      logo: BCHLogo,
      ticker: "BCH",
      isSwapEnabled: true,
    },
    {
      name: "BitcoinCashTestnet",
      currencyName: "Bitcoin Cash",
      logo: BCHLogo,
      ticker: "BCH",
      isTestnet: true,
    },
    {
      name: "BitcoinSV",
      logo: BSVLogo,
      ticker: "BSV",
      isHidden: true,
    },
    {
      name: "Ethereum",
      currencyName: "Ether",
      logo: EthLogo,
      ticker: "ETH",
      chainId: 1,
      isSwapEnabled: true,
    },
    {
      name: "SepoliaTestnet",
      currencyName: "Ether",
      logo: EthLogo,
      ticker: "ETH",
      isTestnet: true,
      chainId: 11155111,
    },
    {
      name: "Solana",
      logo: SolLogo,
      ticker: "SOL",
      isSwapEnabled: true,
    },
    {
      name: "Polygon",
      chainId: 137,
      currencyName: "Polygon Ecosystem Token",
      logo: PolygonLogo,
      ticker: "POL",
      isSwapEnabled: true,
    },
    {
      name: "Avalanche",
      chainId: 43114,
      currencyName: "Avalanche",
      logo: AvalancheLogo,
      ticker: "AVAX",
      isSwapEnabled: true,
    },
    {
      name: "PolygonTestnet",
      currencyName: "Polygon Ecosystem Token",
      chainId: 80001,
      logo: PolygonLogo,
      ticker: "POL",
      isTestnet: true,
      isHidden: true,
    },
    {
      name: "BNB",
      chainId: 56,
      currencyName: "BNB",
      logo: BNBLogo,
      ticker: "BNB",
      isSwapEnabled: true,
    },
    {
      name: "Arbitrum",
      chainId: 42161,
      currencyName: "ETH",
      logo: ArbitrumLogo,
      ticker: "ETH",
      isSwapEnabled: true,
    },
    {
      name: "Base",
      chainId: 8453,
      currencyName: "ETH",
      logo: BaseLogo,
      ticker: "ETH",
      isSwapEnabled: true,
    },
    {
      name: "Optimism",
      chainId: 10,
      currencyName: "ETH",
      logo: OptimismLogo,
      ticker: "ETH",
      isSwapEnabled: true,
    },
    {
      name: "OpBnb",
      chainId: 204,
      currencyName: "BNB",
      logo: BNBLogo,
      ticker: "BNB",
    },
    {
      name: "BNBTestnet",
      currencyName: "BNB",
      chainId: 97,
      logo: BNBLogo,
      ticker: "BNB",
      isTestnet: true,
      isHidden: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 11155111,
      hostChain: {
        tokenAddress: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
        name: "SepoliaTestnet",
        logo: EthLogo,
      },
      isTestnet: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 80001,
      hostChain: {
        tokenAddress: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
        name: "PolygonTestnet",
        logo: PolygonLogo,
      },
      isTestnet: true,
      isHidden: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      hostChain: {
        tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
        name: "SolanaDevnet",
        logo: SolLogo,
      },
      isTestnet: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 11155111,
      hostChain: {
        tokenAddress: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
        name: "SepoliaTestnet",
        logo: EthLogo,
      },
      isTestnet: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      hostChain: {
        tokenAddress: "21984",
        name: "PolkadotAssetHubTestnet",
        logo: DotLogo,
      },
      isTestnet: true,
      isHidden: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      hostChain: {
        tokenAddress: "31337",
        name: "PolkadotAssetHubTestnet",
        logo: DotLogo,
      },
      isTestnet: true,
    },
    {
      name: "PolkadotAssetHub",
      ticker: "DOT",
      logo: DotLogo,
      isHidden: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      hostChain: {
        tokenAddress: "1984",
        name: "PolkadotAssetHub",
        logo: DotLogo,
      },
      isHidden: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      hostChain: {
        tokenAddress: "1337",
        name: "PolkadotAssetHub",
        logo: DotLogo,
      },
      isHidden: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 80001,
      hostChain: {
        tokenAddress: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
        name: "PolygonTestnet",
        logo: PolygonLogo,
      },
      isTestnet: true,
      isHidden: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 1,
      hostChain: {
        tokenAddress: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        name: "Ethereum",
        logo: EthLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 137,
      hostChain: {
        tokenAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
        name: "Polygon",
        logo: PolygonLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 137,
      hostChain: {
        tokenAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
        name: "Polygon",
        logo: PolygonLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Wrapped Ether",
      ticker: "ETH",
      logo: WethLogo,
      chainId: 137,
      hostChain: {
        tokenAddress: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
        name: "Polygon",
        logo: PolygonLogo,
      },
      isHidden: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 56,
      hostChain: {
        tokenAddress: "0x55d398326f99059ff775485246999027b3197955",
        name: "BNB",
        logo: BNBLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      hostChain: {
        tokenAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
        name: "Solana",
        logo: SolLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 42161,
      hostChain: {
        tokenAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        name: "Arbitrum",
        logo: ArbitrumLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 43114,
      hostChain: {
        tokenAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
        name: "Avalanche",
        logo: AvalancheLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      hostChain: {
        tokenAddress: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
        name: "Tron",
        logo: TronLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 10,
      hostChain: {
        tokenAddress: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
        name: "Optimism",
        logo: OptimismLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      chainId: 204,
      hostChain: {
        tokenAddress: "0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3",
        name: "OpBnb",
        logo: BNBLogo,
      },
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 1,
      hostChain: {
        tokenAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        name: "Ethereum",
        logo: EthLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Bridged USD Coin",
      ticker: "USDC.e",
      logo: USDCLogo,
      chainId: 137,
      hostChain: {
        tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
        name: "Polygon",
        logo: PolygonLogo,
      },
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      hostChain: {
        tokenAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
        name: "Solana",
        logo: SolLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Euro Coin",
      ticker: "EURC",
      logo: EUROCLogo,
      hostChain: {
        tokenAddress: "HzwqbKZw8HxMN6bF2yFZNrht3c2iXXzpKcFu7uBEDKtr",
        name: "Solana",
        logo: SolLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 56,
      hostChain: {
        tokenAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
        name: "BNB",
        logo: BNBLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 42161,
      hostChain: {
        tokenAddress: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
        name: "Arbitrum",
        logo: ArbitrumLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Bridged USD Coin",
      ticker: "USDC.e",
      logo: USDCLogo,
      chainId: 42161,
      hostChain: {
        tokenAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
        name: "Arbitrum",
        logo: ArbitrumLogo,
      },
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 8453,
      hostChain: {
        tokenAddress: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        name: "Base",
        logo: BaseLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "USD Coin",
      ticker: "USDC",
      logo: USDCLogo,
      chainId: 10,
      hostChain: {
        tokenAddress: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
        name: "Optimism",
        logo: OptimismLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Binance USD",
      ticker: "BUSD",
      logo: BUSDLogo,
      chainId: 56,
      hostChain: {
        tokenAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
        name: "BNB",
        logo: BNBLogo,
      },
      isHidden: true,
    },
    {
      name: "Basic Attention Token",
      ticker: "BAT",
      logo: BatLogo,
      chainId: 1,
      hostChain: {
        tokenAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
        name: "Ethereum",
        logo: EthLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Basic Attention Token",
      ticker: "BAT",
      logo: BatLogo,
      hostChain: {
        tokenAddress: "EPeUFDgHRxs9xxEPVaL6kfGQvCon7jmAWKVUHuux1Tpz",
        name: "Solana",
        logo: SolLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Basic Attention Token",
      ticker: "BAT",
      logo: BatLogo,
      chainId: 137,
      hostChain: {
        tokenAddress: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
        name: "Polygon",
        logo: PolygonLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Basic Attention Token",
      ticker: "BAT",
      logo: BatLogo,
      chainId: 56,
      hostChain: {
        tokenAddress: "0x101d82428437127bf1608f699cd651e6abf9766e",
        name: "BNB",
        logo: BNBLogo,
      },
      isSwapEnabled: true,
    },
    {
      name: "Basic Attention Token",
      ticker: "BAT",
      logo: BatLogo,
      chainId: 11155111,
      hostChain: {
        tokenAddress: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
        name: "SepoliaTestnet",
        logo: EthLogo,
      },
      isTestnet: true,
    },
    {
      name: "SolanaDevnet",
      logo: SolLogo,
      ticker: "SOL",
      isTestnet: true,
    },
    {
      name: "Polkadot",
      logo: DotLogo,
      ticker: "DOT",
      isHidden: true,
    },
    {
      name: "PolkadotTestnet",
      logo: DotLogo,
      ticker: "PAS",
      isTestnet: true,
    },
    {
      name: "PolkadotAssetHubTestnet",
      logo: DotLogo,
      ticker: "PAS",
      isTestnet: true,
    },
    {
      name: "TronTestnet",
      logo: TronLogo,
      ticker: "TRX",
      isTestnet: true,
    },
    {
      name: "Tether",
      ticker: "USDT",
      logo: UDSTLogo,
      hostChain: {
        tokenAddress: "TSrUgwP9NPHKMcWPtHRRWcoxFV4JU6R9qk",
        name: "TronTestnet",
        logo: TronLogo,
      },
      isTestnet: true,
    },
    {
      name: "Tron",
      logo: TronLogo,
      ticker: "TRX",
      isSwapEnabled: true,
    },
    {
      name: "US Dollar",
      ticker: "USD",
      logo: USDLogo,
      isHidden: true,
      isFiat: true,
    },
    {
      name: "Brazilian Real",
      ticker: "BRL",
      logo: BRLLogo,
      isHidden: true,
      isFiat: true,
    },
    {
      name: "Mexican Peso",
      ticker: "MXN",
      logo: MXNLogo,
      isHidden: true,
      isFiat: true,
    },
    {
      name: "Fiat",
      logo: EUROLogo,
      ticker: "EUR",
      isTestnet: false,
      isDisabled: true,
    },
    {
      name: "Fiat",
      logo: GBPLogo,
      ticker: "GBP",
      isTestnet: false,
      isDisabled: true,
    },
    // Hidden, archived
    // {
    //   name: 'SolanaTestnet',
    //   logo: SolLogo,
    //   ticker: 'SOL',
    //   isTestnet: true,
    //   isHidden: true
    // }
  ];
};

export const getMethod = (
  network: string,
  token?: string,
): ManagedPaymentMethod => {
  let method: ManagedPaymentMethod | undefined;
  const normalizedNetwork = network.toLowerCase();
  const normalizedToken = token?.toLowerCase();
  const methods = getPaymentMethods();

  if (network === "Fiat") {
    method = methods.find((m) => m.ticker.toLowerCase() === normalizedToken);
  } else {
    method = methods.find((m) => {
      if (token) {
        return m.hostChain?.tokenAddress.toLowerCase() ===
            normalizedToken &&
          normalizedNetwork === m.hostChain?.name.toLowerCase();
      } else {
        return m.name.toLowerCase() === normalizedNetwork;
      }
    });

    if (!method && token) {
      method = methods.find((m) => {
        const methodNetwork = (m.hostChain?.name ?? m.name).toLowerCase();
        return methodNetwork === normalizedNetwork &&
          m.ticker.toLowerCase() === normalizedToken;
      });
    }
  }

  if (!method) {
    return {
      name: "Unknown",
      logo: null,
      ticker: "Unknown",
    };
  }

  return method;
};

export const getMethodLogoByTicker = (ticker: string): any => {
  const method = getPaymentMethods().find((m) => m.ticker === ticker);

  if (!method) {
    return null;
  }

  return method.logo;
};

export const getMethodByTicker = (ticker: string): ManagedPaymentMethod | undefined => {
  return getPaymentMethods().find((m) => m.ticker.toLowerCase() === ticker.toLowerCase() && !m.isTestnet)
};

export const methodsForTicker = (ticker: string, testMode: boolean): ManagedPaymentMethod[] => {
  return getPaymentMethods().filter((m) =>
    m.ticker.toLowerCase() === ticker.toLowerCase() && (testMode ? !!m.isTestnet : !m.isTestnet)
  )
};

export const methodNetworkName = (method: ManagedPaymentMethod): string => method.hostChain?.name ?? method.name

export const methodTokenAddress = (method: ManagedPaymentMethod): string | undefined => method.hostChain?.tokenAddress

/**
 * Networks each unified-treasury asset settles on, mirroring the backend's
 * unified instrument sets. Unified balance rows carry only an asset ticker and
 * no network, so surfaces that need a concrete rail (sends, payouts) expand
 * one unified row into one option per settlement network.
 */
export const UNIFIED_ASSET_NETWORKS: Record<string, string[]> = {
  USDC: ['Ethereum', 'Arbitrum', 'Base', 'Polygon', 'Solana', 'Optimism', 'BNB'],
  USDT: ['Ethereum', 'Arbitrum', 'Polygon', 'Avalanche', 'Solana', 'Tron', 'Optimism', 'BNB'],
  ETH: ['Ethereum', 'Arbitrum', 'Base', 'Optimism']
}

/**
 * Per-network `{ network, token }` options for a unified asset, resolved
 * through the mainnet method registry. Networks the registry doesn't list
 * are skipped: there is no token address or metadata to offer for them.
 */
export const unifiedAssetNetworkOptions = (asset: string): Array<{ network: string, token?: string }> => {
  const networks = UNIFIED_ASSET_NETWORKS[asset.toUpperCase()] ?? []
  const methods = methodsForTicker(asset, false)
  // Single-network assets (LTC, DOGE, BTC, ...) have no map entry: offer
  // every enabled registry instrument for the ticker instead of nothing.
  if (networks.length === 0) {
    return methods
      .filter(m => !m.isDisabled && !m.isHidden)
      .map(m => ({ network: methodNetworkName(m), token: methodTokenAddress(m) }))
  }
  return networks.flatMap(network => {
    const method = methods.find(m => methodNetworkName(m) === network && !m.isDisabled && !m.isHidden)
    return method ? [{ network, token: methodTokenAddress(method) }] : []
  })
}

/**
 * The unified-treasury wait state ships as `awaitingInventory`; surfaces show
 * white-label copy for it and leave every other status untouched.
 */
export const withdrawalStatusDisplay = (status: string): string =>
  status === 'awaitingInventory' ? 'Awaiting funds' : status

export const testNetworks = [
  ...new Set(
    getPaymentMethods().filter((a) => a.isTestnet).map((a) =>
      a.hostChain?.name ?? a.name
    ),
  ),
];

export const prodNetworks = [
  ...new Set(
    getPaymentMethods().filter((a) => !a.isTestnet && !a.isFiat).map((a) =>
      a.hostChain?.name ?? a.name
    ),
  ),
];

export const depositStatusLabel = (status: DepositStatus): string => {
  switch (status) {
  case 'inReview': return 'In review'
  case 'failed': return 'Failed'
  default: return 'Complete'
  }
}

export const depositStatusColor = (status: DepositStatus): string => {
  switch (status) {
  case 'inReview': return '#b26a00'
  case 'failed': return '#c0392b'
  default: return 'inherit'
  }
}
